export default {
  name: 'TTableExpand',
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null
    }
  },
  render: (h, ctx) => {
    const params = {
      row: ctx.props.row,
      index: ctx.props.index
    }
    if (ctx.props.column) params.column = ctx.props.column
    if (ctx.props.render) return ctx.props.render(h, params)
    if (ctx.props.renderHeader) return ctx.props.renderHeader((h, params))
    // return ctx.props.render(h, params)
  }
}



// WEBPACK FOOTER //
// ./src/components/table/expand.js